import {
  InstructorTeachingRow,
  TeachingDifferenceState,
} from "@services/types/instructor/instructorTypes";

export const getDifferenceState = (row: InstructorTeachingRow): TeachingDifferenceState | null => {
  if (row.contractedBlocks === null || row.difference === null) {
    return null;
  }

  if (row.difference === 0) {
    return "success";
  }

  return row.plannedBlocks > row.contractedBlocks ? "error" : "warning";
};

// Pending UX confirmation (design open question 3): Figma shows the difference as a
// negative number for both deficit and excess, while backend sends the raw value of
// `contractedBlocks - plannedBlocks`. Default: render the backend value as-is.
export const formatDifference = (difference: number | null): string => {
  if (difference === null) {
    return "—";
  }

  return `${difference}`;
};
